
<div [ngStyle]="{ 'display' : this.navaidsFilterController.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <div class="loading" [ngClass]="this.navaidService.loading? 'active' : ''">
    <div></div>
  </div>
  <form autocomplete="off"
    id="ngForm1"
    [ngClass]="[this.navaidsFilterController.active ? 'active' : '',  tabsService.fullScreenMode ? 'fullscreen' : '']"
    name="ngForm1"
    #ngForm1="ngForm"
    id="navaidPrimaryForm"
  >
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Fields Options</h4>
          <span> </span>
        </div>
        <div class="dropdown-fields">
          <div>
            <label for="">Fields</label>
            <select  name="filter_type" id="filter_type" (change)="typeChanged($event.target.value)">
              <option value="type">Type</option>
              <option value="icao_ecac_enp">ICAO Country Code (ECAC+ENP)</option>
              <option value="icao_world">ICAO Country Code(rest of the world)</option>
              <option value="doc">DOC</option>
              <option value="doc_max">DOC Maximum Altitude</option>
              <option value="operational_status">DME/TACAN Operational status</option>
              <option value="operational_at_date">DME/TACAN Operational at date</option>
              <option value="date_comissioning">DME/TACAN Date for comissioning</option>
              <option value="date_replacement">DME/TACAN Date for replacement</option>
              <option value="planned_removal">DME/TACAN Date of planned removal</option>
              <option value="vhf_frequency">VHF tuning frequency</option>
              <option value="purpose">DME/TACAN purpose</option>
              <option value="channel">Channel</option>
              <option value="output_power">Transmitter output power</option>
              <option value="eirp">Declared EIRP</option>
              <option value="fom">ARINC 424 FOM</option>
              <option value="vor_type">VOR Type</option>
              <option value="vor_operational_status">VOR Operational Status</option>
              <option value="vor_operational_at_date">VOR Operational at Date</option>
              <option value="vor_operational_comissioning">VOR Date for comissioning</option>
              <option value="vor_replacement">VOR Date for replacement</option>
              <option value="vor_planned_removal">VOR Date of planned removal</option>
              <option value="navaids_on_map">Selected Navaids on the map</option>
              <option value="published">Published</option>
              <option value="bias">Bias</option>
              <option value="antenna_type">Antenna Type</option>

            </select>
          </div>
          <div *ngIf="!showPublishedSlider">
            <label for=""></label>
            <select *ngIf="this.values.length > 0" id="values" name="values" [disabled]="dropdown_values_enabled ? false : true">
                <option *ngFor="let item of this.values" [value]="item">{{item}}</option>
            </select>
            <select *ngIf="this.valuesIcao.length > 0" id="values" name="values" [disabled]="dropdown_values_enabled ? false : true">
              <option *ngFor="let item of this.valuesIcao" [value]="item.icaocode">{{item.icaocode}} - {{item.countryname}}</option>
          </select>
          </div>

          <div class="input-fields" *ngIf="showPublishedSlider">
            <label style="width: 25%;" for=""></label>
            <div style="justify-content: flex-start;width: 50%;">
              <input type="checkbox" id="filter_publishedNavaids" name="filter_publishedNavaids" [(ngModel)]="filter_publishedNavaids" [value]="true" [disabled]="!showPublishedSlider">
              <label for="filter_publishedNavaids" style="width: calc(100% - 20px);">{{this.updatePublishedLabel()}}</label>
            </div>
          </div>

        </div>
        <div class="input-fields">
          <div>
            <label for="">Min Value</label>
            <div>
              <input
                type="number"
                id="min_value"
                name="min_value"
                [disabled]="min_max_enabled ? false : true"
              />
              <span class="error" *ngIf="this.errorMessage[0] != null && min_max_enabled">
                {{this.errorMessage[0]}}
              </span>
          </div>
          </div>
          <div>
            <label for="">Max Value</label>
            <div>
              <input
                type="number"
                id="max_value"
                name="max_value"
                [disabled]="min_max_enabled ? false : true"
              />
              <span class="error" *ngIf="this.errorMessage[1] != null && min_max_enabled">
                {{this.errorMessage[1]}}
              </span>
          </div>
          </div>
          <div>
            <label for="">Min Date</label>
            <div class="coordenates">
              <input
                type="date"
                id="min_date"
                name="min_date"
                [disabled]="min_max_date_enabled ? false : true"
              />
              <span class="error" *ngIf="this.errorMessage[2] != null && min_max_date_enabled">
                {{this.errorMessage[2]}}
              </span>
          </div>
          </div>
          <div>
            <label for="">Max Date</label>
            <div class="coordenates">
              <input
                type="date"
                id="max_date"
                name="max_date"
                [disabled]="min_max_date_enabled ? false : true"
              />
              <span class="error" *ngIf="this.errorMessage[3] != null && min_max_date_enabled">
                {{this.errorMessage[3]}}
              </span>
          </div>
          </div>
          <div class="btn">
            <button type="submit" (click)="showErrorMessage()? addFilter() : false">Add Filter</button>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Applied Filters</h4>
          <span> </span>
        </div>
        <div class="table-fields">
          <div>
            <div class="scrollable">
              <table >
                <thead>
                  <tr>
                    <th>Field</th>
                    <th scope="col">Value</th>
                    <th scope="col">Active</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let filter of this.navaidsFilterController.filters; let i = index" [class.highlighted]="filter.isSelected" (click)="selectFilter(filter)">
                    <td>{{ filter.field }}</td>
                    <td>{{ filter.value }}</td>
                    <td>{{ filter.active }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="btn">
              <button type="submit" (click)="applyFilter()">Apply Filter</button>
              <button type="submit" (click)="deleteSelectedFilterFromList()">Remove Filter</button>
              <button type="submit" (click)="selectFeaturesOnMap()">Select on Map</button>
              <button type="submit" (click)="resetFilters()">Reset</button>
            </div>
          </div>
        </div>
        <div class="notes">{{pointsService.informationMessageNavaids}}</div>
      </div>
    </div>
</form>

</div>
